module.exports = __webpack_public_path__ + "static/media/ts6tj93.18be8962.png";